export default class Types {
    static LANGUAGE_EN = 'en';
    static LANGUAGE_RU = 'ru';

    static LANGUAGES = {
        [Types.LANGUAGE_EN]: 'English',
        [Types.LANGUAGE_RU]: 'Русский',
    };

    static THEMES = {
        system: 'system',
        dark: 'dark',
        light: 'light'
    }

    static THEME_COLORS = {
        default: 'default',
        dark: 'dark',
    };

    static KEY_CODES = {
        BACKSPACE: 8,
        ENTER: 13,
        ESC: 27,
        CTRL: 17,
        ARROW_LEFT: 37,
        ARROW_RIGHT: 39,
        DELETE: 46,
    };
}